<template>
  <div>
    <transition name="modal" v-if="show">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="close">
          <div class="modal-container small">
            <div class="mt-3 custom-modal-body text-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100"
                height="100"
                fill="#dc3545"
                class="fa fa-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <h2 class="h3 mt-4">Are You Sure?</h2>
              <p>This action cannot be reversed.</p>
            </div>
            <div class="modal-footer justify-content-between pt-3 pb-3">
              <a href="#" class="btn btn-primary float-start" @click.prevent="$emit('close')"><i class="fa fa-times me-2"></i>Cancel</a>
              <a href="#" class="btn btn-warning" @click.prevent="$emit('confirmed')"><i class="far fa-check me-2"></i>Yes, Delete It.</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default() {
        return false;
      },
    },
    width: {
      default() {
        return "medium";
      },
    },
  },

  methods: {
    close(e) {
      if (e.target.className == "modal-wrapper") {
        this.$emit("close");
      }
    },
  },
};
</script>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 99999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-header {
  padding: 0 !important;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: top;
}

.modal-container {
  margin: 40px auto;
  padding: 10px 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;

  &.small {
    width: 35%;
  }

  &.medium {
    width: 50%;
  }

  &.large {
    width: 80%;
  }

  @media (max-width: 768px) {
    width: 80% !important;
  }
}

.modal-body {
  overflow-y: auto;
  max-height: 80vh;
}

.custom-modal-body {
  overflow-y: auto;
  max-height: 80vh;
}

.modal-default-button {
  float: right;
}

.modal-close {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
